import classNames from 'classnames';
import { GerenciadorPrecos } from '../../../../../@types/GerenciadorPrecos';
import { Tag, TagProps } from '../../../../../components/Tag';
import styles from './PriceStatusIndicator.module.scss';

type PriceTypeIndicatorProps = {
  priceStatus?: GerenciadorPrecos.RowData['priceStatus'];
} & TagProps;

const priceTypeMap = new Map([
  ['EDITED', 'EDITADO'],
  ['EDITADO', 'EDITADO'],
  ['ERP', 'ERP'],
  ['AUTO', 'AUTO'],
  ['OTIMIZADO', 'OTIMIZADO'],
]);

const PriceStatusIndicator = ({ className, priceStatus = undefined, size = 'xsmall', skin = 'blue', ...props }: PriceTypeIndicatorProps) => {
  const skinColor = !priceStatus ? 'blue' : ['OTIMIZADO'].includes(priceStatus) ? 'pink' : 'blue';

  if (!priceStatus) return null;
  return (
    <Tag className={classNames(className, styles.tag)} size={size} skin={skinColor} {...props}>
      {priceTypeMap.get(priceStatus)}
    </Tag>
  );
};

export default PriceStatusIndicator;
